import { Table, Tag } from "antd";
import React from "react";
import { Card, CardBody } from "reactstrap";
import {
  fetchInventoryCategories,
  fetchInventorySubCategories,
} from "../../../../../api/inventory.api";
import styles from "./styles.module.scss";
import AddSubCategoryDialog from "./form";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const InventorySubCategory = () => {
  const [categories, setCategories] = React.useState([]);
  const [subCategories, setSubCategories] = React.useState([]);
  const [showSubCategoryDialog, setShowSubCategoryDialog] =
    React.useState(false);

  const getCategories = React.useCallback(async () => {
    try {
      const categories = await fetchInventoryCategories();
      setCategories(categories);

      const subCategories = await fetchInventorySubCategories();
      setSubCategories(
        subCategories.sort((a, b) => {
          return b.id - a.id;
        })
      );
    } catch (error) {
      console.log(error);
    }
  }, []);

  const groupedSubCategories = React.useMemo(() => {
    // Group subcategories by `inventory_category`
    const grouped = subCategories.reduce((acc, subCategory) => {
      const { inventory_category } = subCategory;

      if (Array.isArray(acc[inventory_category])) {
        acc[inventory_category].push(subCategory);
      } else {
        acc[inventory_category] = [subCategory];
      }

      return acc;
    }, {});

    return grouped;
  }, [subCategories]);

  React.useEffect(() => {
    getCategories();
  }, [getCategories]);

  const tableColumns = React.useMemo(() => {
    const columns = [
      {
        key: "id",
        title: "S. No.",
        dataIndex: "id",
      },
      {
        key: "subcategory_name",
        title: "SubCategory Name",
        dataIndex: "subcategory_name",
      },
      {
        key: "actions",
        title: "Actions",
        render: (subCategory) => {
          return (
            <div className={styles.actions}>
              <Tag color="blue">
                <EditOutlined />
              </Tag>
              <Tag color="red">
                <DeleteOutlined />
              </Tag>
            </div>
          );
        },
      },
    ];

    return columns;
  }, []);

  return (
    <div className={styles.container}>
      <AddSubCategoryDialog
        open={showSubCategoryDialog}
        onClose={() => setShowSubCategoryDialog(false)}
        refresh={getCategories}
      />
      <div>
        <Card>
          <CardBody>
            <div className={styles.header}>
              <h5>Subcategories</h5>
              <div className={styles.actions}>
                <Tag
                  color="blue"
                  onClick={() => setShowSubCategoryDialog(true)}
                >
                  Add Subcategory
                </Tag>
              </div>
            </div>
            <div className={styles.categories}>
              <Table
                columns={tableColumns}
                dataSource={subCategories.sort((a, b) => {
                  return a.id - b.id;
                })}
                pagination={false}
                rowKey="id"
              />
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default InventorySubCategory;
